import React from 'react'

import { ButtonGroup, ButtonGroupProps } from '../forms/button-group/button-group.js'
import { Checkbox, CheckboxProps } from '../forms/checkbox/checkbox.js'
import { Select, SelectProps } from '../forms/select/select.js'
import { GridColumn } from '../grid/grid-column.js'
import { Grid } from '../grid/grid.js'

export interface AuthProps {
    title: string
    subtitle: string
    authenticationMethodField?: AuthFieldProps
    authenticationMethodButtons?: ButtonGroupProps
    isCentered?: boolean
    pepTermsCheckbox?: CheckboxProps
    termsCheckbox?: CheckboxProps
}

export interface AuthFieldProps {
    select: SelectProps
}

const AuthMethodField = (props: AuthFieldProps): JSX.Element => {
    return <Select {...props.select} />
}

export const AuthStep = (props: AuthProps): JSX.Element => {
    return (
        <Grid align={props.isCentered ? ['center-xs'] : undefined}>
            <GridColumn width={['lg-8']}>
                <div className="text">
                    <h3>{props.title}</h3>
                    <p>{props.subtitle}</p>
                    {props.authenticationMethodField && <AuthMethodField {...props.authenticationMethodField} />}
                    {props.authenticationMethodButtons && <ButtonGroup {...props.authenticationMethodButtons} />}
                    {props.termsCheckbox && <Checkbox {...props.termsCheckbox} />}
                    {props.pepTermsCheckbox && <Checkbox {...props.pepTermsCheckbox} />}
                </div>
            </GridColumn>
        </Grid>
    )
}
